// TODO: Проверить что из этого уже не работает
$(window).scroll(function() {
    if ($(this).scrollTop() > 100) {
        if ($('#upbutton').is(':hidden')) {
            $('#upbutton').css({opacity : 1}).fadeIn('slow');
        }
    } else { $('#upbutton').stop(true, false).fadeOut('fast'); }
});

// TODO: Проверить что из этого уже не работает
$('#upbutton').click(function() {
    $('html, body').stop().animate({scrollTop : 0}, 1300);
});

// TODO: Проверить что из этого уже не работает (Выдает ошибку на пустых хэшах)
// $(function(){
//     $('a[href^="#"]').on('click', function(event) {
//
//         event.preventDefault();
//
//         var sc = $(this).attr("href"),
//             dn = $(sc).offset().top;
//
//         $('html, body').animate({scrollTop: dn}, 1300);
//
//     });
// });